import { Link } from "react-router-dom";
import { AlertCircle, Home, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ChronicleNotFoundProps {
  reason?: "disabled" | "not-found";
}

const ChronicleNotFound = ({ reason = "not-found" }: ChronicleNotFoundProps) => {
  const isDisabled = reason === "disabled";

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-sm space-y-6 text-center">
        <div className="p-4 rounded-full bg-muted mx-auto w-fit">
          {isDisabled ? (
            <Lock className="h-10 w-10 text-muted-foreground" />
          ) : (
            <AlertCircle className="h-10 w-10 text-muted-foreground" />
          )}
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-bold">
            {isDisabled ? "Chronicle Not Available" : "Page Not Found"}
          </h1>
          <p className="text-muted-foreground text-sm">
            {isDisabled
              ? "OptiChronicle is not currently enabled for this environment."
              : "The page you're looking for doesn't exist or is coming soon."}
          </p>
        </div>
        {!isDisabled && (
          <Button variant="outline" asChild className="w-full">
            <Link to="/chronicle">
              <Home className="mr-2 h-4 w-4" /> Back to Chronicle
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ChronicleNotFound;
